import { Controller } from '@hotwired/stimulus';
import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import { UploadFilled, Upload } from '@element-plus/icons-vue';
import FileImport from '/components/FileImport.vue';

export default class extends Controller {
  static targets = ['vueapp'];

  connect() {
    const app = createApp(FileImport);
    app.component('UploadFilled', UploadFilled);
    app.component('Upload', Upload);
    app.use(ElementPlus);
    app.mount(this.vueappTarget);
  }
}
